import type React from "react";
import type { HTMLAttributes } from "react";
import { Link } from "./styles";

interface IconLinkProps extends HTMLAttributes<HTMLAnchorElement> {
  testId?: string;
  SvgIcon: React.ComponentType;
  href: string;
}

export const IconLink: React.FC<IconLinkProps> = ({
  testId,
  SvgIcon,
  href,
  ...rest
}) => {
  return (
    <Link href={href} data-testid={testId} {...rest}>
      <SvgIcon />
    </Link>
  );
};
